import { render, staticRenderFns } from "./percentageCancelFrom.vue?vue&type=template&id=5134e0ca&scoped=true"
import script from "./percentageCancelFrom.vue?vue&type=script&lang=js"
export * from "./percentageCancelFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5134e0ca",
  null
  
)

export default component.exports